<template>
  <div class="check-record-cla">
    <zkThreeRow>
      <div slot="search">
        <el-form
          :model="checkForm"
          ref="ruleForm"
          class="demo-ruleForm"
          :inline="true"
        >
          <el-form-item :label="$t('witnessRecord.checkTime')" prop="time">
            <el-date-picker
              class="pickData_cla"
              v-model="value2"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="-"
              :start-placeholder="$t('common.startTime')"
              :end-placeholder="$t('common.endTime')"
              :picker-options="pickerOptions"
              clearable
            ></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('witnessRecord.checkResult')" prop="status">
            <el-select
              v-model="checkForm.status"
              :placeholder="$t('common.chooseOptions')"
              clearable
            >
              <el-option
                v-for="item in statusList"
                :key="item.key"
                :label="item.label"
                :value="item.key"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Sn" prop="sn">
            <el-input v-model="checkForm.sn"></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('witnessRecord.employeeNo')"
            prop="employeeNo"
          >
            <el-input v-model="checkForm.employeeNo"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" @click="searchCheckRecord">{{
              $t('operation.search')
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div slot="table">
        <zk-table
          :data="checkTable"
          :columns="checkColumn"
          :showTableMenu="true"
        >
          <span slot="tableTip">
            <span class="normal-cla"
              ><span class="base-circle"></span>
              {{ $t('witnessRecord.normalTemperature') }}</span
            >
            <span class="error-cla"
              ><span class="base-circle"></span>
              {{ $t('witnessRecord.abnormalTemperature') }}</span
            >
          </span>
        </zk-table>
        <div class="pagination-margin-top">
          <el-pagination
            background
            @size-change="pageSizeChange(arguments[0], getCheckRecordList)"
            @current-change="curPageChange(arguments[0], getCheckRecordList)"
            :current-page="pager.curPage"
            :page-size="pager.pageSize"
            layout="total, prev, pager, next, sizes, jumper"
            :total="pager.total"
          ></el-pagination>
        </div>
        <verify-photo ref="verifyPhoto"></verify-photo>
      </div>
    </zkThreeRow>
  </div>
</template>

<script>
import { getStartTime, getEndTime } from '@/utils/utils.js'
import { getCheckRecordList } from '@/services/attendanceApi'
import pickerOptions from '@/utils/pickerOptions.js'
export default {
  inject: [
    'statusList',
    'hasStatus',
    'hasTemperature',
    'hasMask',
    'hasVerifyMode'
  ],
  data() {
    let _self = this
    return {
      pickerOptions: pickerOptions(this),
      value2: [],
      checkForm: {
        time: '',
        status: '',
        sn: '',
        employeeNo: '',
        startTime: '',
        endTime: '',
        appId: ''
      },
      checkTable: [],
      checkColumn: [
        {
          label: 'Sn',
          prop: 'sn'
        },
        {
          label: this.$t('witnessRecord.employeeNo'),
          prop: 'employeeNo'
        },
        {
          label: this.$t('witnessRecord.checkTime'),
          prop: 'time'
        },
        {
          label: this.$t('witnessRecord.checkResult'),
          prop: 'status',
          render: (h, params) => {
            return h(..._self.hasStatus(params.row.status))
          }
        },
        {
          label: this.$t('witnessRecord.temperature'),
          prop: 'temperature',
          visiable: true,
          render: (h, params) => {
            return h(..._self.hasTemperature(params.row.temperature))
          }
        },
        {
          label: this.$t('witnessRecord.hasMask'),
          prop: 'maskStatus',
          visiable: true,
          render: (h, params) => {
            return h(..._self.hasMask(params.row.maskStatus))
          }
        },
        {
          label: this.$t('witnessRecord.checkMode'),
          prop: 'deviceVerifyMode',
          visiable: true,
          render: (h, params) => {
            return h(..._self.hasVerifyMode(params.row.deviceVerifyMode))
          }
        },
        {
          label: this.$t('attendanceRecord.verifyPhoto'),
          prop: 'verifyPhoto',
          render: (h, params) => {
            if (params.row.verifyPhoto === undefined || params.row.verifyPhoto === '') {
              return h('span')
            } else {
              return h(
                'span',
                {
                  style: {
                    color: '#4db22f',
                    cursor: 'pointer'
                  },
                  on: {
                    click: () => {
                      this.$refs.verifyPhoto.showPhotoDia(params.row.verifyPhoto)
                    }
                  }
                },
                this.$t('attendanceRecord.view')
              )
            }
          }
        }
      ]
    }
  },
  watch: {
    checkColumn: {
      handler(val, old) {
        this.checkColumn = val
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    searchCheckRecord() {
      this.pager.curPage = 1
      this.getCheckRecordList()
    },
    getCheckRecordList() {
      let valueLength = this.value2 && this.value2.length === 2
      this.checkForm.startTime = valueLength
        ? getStartTime(this.value2[0]) / 1000
        : ''
      this.checkForm.endTime = valueLength
        ? parseInt(getEndTime(this.value2[1]) / 1000)
        : ''

      if (sessionStorage.getItem('role') === '"developer"') {
        this.checkForm.appId = this.$root.appKey
      }
      let params = {
        params: this.checkForm,
        pager: this.pager
      }
      getCheckRecordList(params)
        .then(data => {
          if (data.code === '00000000') {
            this.checkTable = data.payload.results
            this.pager.total = data.payload.totalRecords
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(e => this.errorMessage())
    }
  },
  mounted() {
    this.showLoad()
    this.$nextTick(() => {
      let _self = this
      let t = setTimeout(() => {
        _self.getCheckRecordList()
        _self.closeLoad()
        clearTimeout(t)
      }, 500)
    })
    this.value2 = []
    let firstDate = new Date()
    firstDate.setDate(1)
    let currentData = new Date()
    this.value2.push(firstDate)
    this.value2.push(currentData)
  }
}
</script>

<style scoped lang="less">
@import '~@/styles/var.less';
.check-record-cla {
  margin-top: 15px;
  .base-circle {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin: 0 10px;
  }
  .error__color {
    color: @ststusFailed;
  }
  .normal__color {
    color: @statusSuccess;
  }
  .normal-cla {
    .normal__color;
    span {
      background: @statusSuccess;
    }
  }
  .error-cla {
    .error__color;
    span {
      background: @ststusFailed;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/enterpriseAdmin/enterpriseSetting/witness/checkRecord.vue